import React from "react";

export function NameKarman({ props }) {
 if (props.Distribute[0] !== "1.0") {
      return (
        <>
          <h1> {props.name} </h1>
        </>
      );
  }
}

export function TitleKarman({ props }) {
  if (props.Distribute[1] !== "2.0") {
      return (
        <>
          <h2>{props.title[0]}</h2>
          <br />
        </>
      );
  }
}

export function LasttitleKarman({ props }) {
  if (props.Distribute[2] !== "3.0") {
        return (
          <>
            <h3> {props.lasttitle[0]} </h3>
            <br />
          </>
        );
  }
}

export function EpigraphKarman({ props }) {
  if (props.Distribute[3] !== "4.0") {
    return (
      <>
        <h4> {props.epigraph[0]} </h4>
        <br />
      </>
    );
  }
}

export function SuportHeaderKarman({props , rangos , DistributeIndex}){
  switch (props.Distribute[DistributeIndex]){
    case "H1":
      return(
       <>
          <h1> {props.name[rangos[0]]} </h1>
      </>
    )
    case "H2":
      return (
        <>
          <h2>{props.title[rangos[0]]}</h2>
          <br />
        </>
    );
    case "H3":
      return (
        <>
        <h3> {props.lasttitle[rangos[0]]} </h3>
        <br />
      </>
    );
    case "H4":
      return (
      <>
        <h4> {props.epigraph[rangos[0]]} </h4>
        <br />
      </>
    );
    case "H5":
      return(
      <>
        <h5>{props.epigraph[rangos[0]]}</h5>
      </>
      )
    default:
      break
  }
}

export function ParafhKarman({ props, rangos ,DistributeIndex }) {
  switch (props.DistributeP[DistributeIndex]) {
    case "5.1":
      return (
        <>
          {props.parrafo.map((e, index) => (
            <p key={index}> {e} </p>
          ))}
        </>
      );
    case "5.2":
      return (
        <>
          <p> {props.parrafo[rangos]} </p>
        </>
      );
      case "5.3":
      let ranger = rangos[0];
      let element = [];
      for (let index = 0; index < rangos[1]; index++) {
        element[index] = ranger;
        ranger += 1;
      }
      return (
        <>
          {element.map((e, index) => (
            <p key={index}> {props.parrafo[e]} </p>
          ))}
        </>
      );
    case "5.4":
        let rangers = rangos[0];
        let elements = [];
        for (let index = 0; index < props.parrafo.length ; index++) {
          elements[index] = rangers;
          rangers += 1;
        }
        return (
          <>
            {elements.map((e, index) => (
              <p key={index}> {props.parrafo[e]} </p>
            ))}
          </>
        );
    default:
      break;
  }
}

export function ImagenKarman ( {props, rangos, DistributeIndex} ) {
  switch (props.DistributeI[DistributeIndex]) {
    case "6.1":
      return (
        <>
          <br />
          <img className="__div_TicTac2"  src={`../${props.img[rangos[0]]}`} alt={`${props.imgDetails[rangos[0]]}`} />
          <br />
        </>
      ) 
    case "6.2":
      return (
        <>
          <div className="div_TicTac">
            <img src={`../${props.img[rangos[0]]}`} alt={`${props.imgDetails[rangos[0]]}`} />
            <p>{props.parrafo[rangos[1]]}</p>
          </div>
        </>
      )
      case "6.3":
        return (
          <>
            <div className="div_TicTac">
              <p>{props.parrafo[rangos[1]]}</p>
              <img src={`../${props.img[rangos[0]]}`} alt={`${props.imgDetails[rangos[0]]}`} />
            </div>
          </>
        )
      case "6.4":  //funciona con tres rangos ( 1ª para primer elemento | "2ªy3ª para rango inicial cuenta cuantos más" )
      let ranger = rangos[1];
      let element = [];
      for (let index = 0; index < rangos[2]; index++) {
        element[index] = ranger;
        ranger += 1;
      }
      return ( 
        <>
          <div className="div_TicTac">
            <div>
              {element.map((e, index) => (
                <p key={index}> {props.parrafo[e]} </p>
              ))}
            </div>
            <img src={`../${props.img[rangos[0]]}`} alt={`${props.imgDetails[rangos[0]]}`} />
          </div>
        </>
      );
      case "6.5": //funciona con tres rangos ( 1ª para primer elemento | "2ªy3ª para rango inicial cuenta cuantos más" )
        let rangers = rangos[1];
        let elements = [];
        for (let index = 0; index < rangos[2]; index++) {
          elements[index] = rangers;
          rangers += 1;
        }
        return ( 
          <>
            <div className="div_TicTac">
                <img src={`../${props.img[rangos[0]]}`} alt={`${props.imgDetails[rangos[0]]}`} />
              <div>
                {elements.map((e, index) => (
                  <p key={index}> {props.parrafo[e]} </p>
                ))}
              </div>
            </div>
          </>
      );
      case "6.6":  //funciona con 1 rango ( 1ª para primer elemento " )
        let rang = rangos[0];
        let elemen = [];
        for (let index = 0; index < props.img.length ; index++) {
          elemen[index] = rang;
          rang += 1;
        }
        return(
          <>
            <div className="div_TicTac-flex">
              {elemen.map((e, index) => (
              <div key={index} >
                <img src={`../${props.img[e]}`} alt={`${props.imgDetails[e]}`}/>
                <p>{`${props.imgDetails[e]}`}</p>
              </div>
            ))}
            </div>
          </>
        );
      case "6.7":
        let rangersPlay = rangos[0];
        let RangerEnd = [];
        for (let index = 0; index < rangos[1]; index++) {
          RangerEnd[index] = rangersPlay;
          rangersPlay += 1;
        }  
        return(
          <>
            <div className="div_TicTac-flex">
              {RangerEnd.map((e, index) => (
              <div key={index} >
                <img  src={`../${props.img[e]}`} alt={`${props.imgDetails[e]}`} />
                 <p>{`${props.imgDetails[e]}`}</p>
              </div>
            ))}
            </div>
          </>
        )
      default:
        break;
  }
}

export function TicTacKarman({props , rangos , DistributeIndex}){
  switch (props.DistributeTT[DistributeIndex]) {
  case "7.1":
  return(
    <>
      {props.tic.map((e,index) =>(
        <div key={index}>
          <h4>{e}</h4>
          <p>{props.tac[index]}</p>
          <br />
        </div>
      ))}
    </>
  )
  case "7.2" :
    return(
    <>
      <div>
        <h4>{props.tic[rangos[0]]}</h4>
        <p>{props.tac[rangos[0]]}</p>
        <br />
      </div>                      
    </>
  )
  case "7.3":
    let ranger = rangos[0];
    let element = [];
    for (let index = 0; index < rangos[1]; index++) {
      element[index] = ranger;
      ranger += 1;
    }
    return(
      <>
        {element.map((e, index) => (
        <div key={index}>
          <h4>{props.tic[e]}</h4>
          <p>{props.tac[e]}</p>
          <br />
        </div>                      
        ))}
      </>
    )
  case "7.4":
      let rangers = rangos[0];
        let elements = [];
        for (let index = 0; index < props.tic.length ; index++) {
   
          elements[index] = rangers;
          rangers += 1;
        }
        return (
          <>
          {elements.map((e, index) => (
            <div key={index}>
              <h4>{props.tic[e]}</h4>
              <p>{props.tac[e]}</p>
              <br />
            </div>                      
            ))}
          </>
        );
  default:
    break;
  }
}

export function CodeKarman ({props}){
    return(
    < div style={{paddingLeft:"2%",margin:"2px"}}>
        {props.code.map( (e ,index) => (
          <code key={index} >
              <p>{e} {": "} {props.code2[index]}{"."}</p> 
          </code>
          
        ))}
        <br /> 
    </div>
  )
}

export function ListKarman ( {props , rangos , DistributeIndex} ){
  switch (props.DistributeList[DistributeIndex] ) {
    case "8.1":
      return (
        <>
          <section>
            {props.list.map((element, index) => (
              <div key={index}>
                <p>{element}</p>
              </div>
            ))}
            <br />
          </section>
       
        </>
      );
    case "8.2":
      let ranger = rangos[0];
      let element = [];
      for (let index = 0; index < rangos[1]; index++) {
        element[index] = ranger;
        ranger += 1;
      }
      return (
        <>
          <section>
            {element.map((e, index) => (
              <div key={index}>
                <p>{props.list[e]}</p>
              </div>
            ))}
            <br />
          </section>
        </>
      );
      default:
        break;
   }
}

export function TableKarman( {props , DistributeIndex} ){
  switch (props.DistributeTable[DistributeIndex]) {
    case "9.1":
      return(
        <>
          <section>
            <div>
              <br />
                <table className="container_table">
                    <thead>
                        <tr>
                          {props.table.map( (e , index) => (
                            <th  key={index}>{ e }</th>
                          ) ) }
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                          {props.cuerpo.map( (e , index) => (
                            <td  key={index}>{ e }</td>
                          ) ) }
                        </tr>
                    </tbody>
                </table> 
              <br />           
            </div>
            <br />
          </section>    
        </>
      )
     case "9.4":
      return(
        <>
           <section>
            <div>
              <br />
                <table className="container_table">
                    <thead>
                        <tr>
                          {props.table.map( (e , index) => (
                            <th  key={index}>{ e }</th>
                          ) ) }
                        </tr> 
                    </thead>
                    <tbody>
                        <tr>
                          {props.cuerpo[0].map( (e , index) => (
                            <td  key={index}>{ e } </td>
                          ) ) }
                        </tr>
                        <tr>
                          {props.cuerpo[1].map( (e , index) => (
                            <td  key={index}>{ e }</td>
                          ) ) }
                        </tr>
                        <tr>
                          {props.cuerpo[2].map( (e , index) => (
                            <td  key={index}>{ e }</td>
                          ) ) }
                        </tr>
                        <tr>
                          {props.cuerpo[3].map( (e , index) => (
                            <td  key={index}>{ e }</td>
                          ) ) }
                        </tr>
                    </tbody>
                </table> 
              <br />           
            </div>
            <br />
          </section> 
        </>
      ) 
    default:


    break;
  }

}
